// extracted by mini-css-extract-plugin
export default {"container":"Stripe_container__FvNlu","content":"Stripe_content__u2BQl","realContent":"Stripe_realContent__iHm0K"};